/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Redact_CoveredInputs */

const da_forside_redact_covered = /** @type {(inputs: Forside_Redact_CoveredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navnet er dækket af et sort felt`)
};

/** @type {(inputs: Forside_Redact_CoveredInputs) => LocalizedString} */
const en_forside_redact_covered = da_forside_redact_covered;

/**

* @param {Forside_Redact_CoveredInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_redact_covered = /** @type {((inputs?: Forside_Redact_CoveredInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Redact_CoveredInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_redact_covered(inputs)
	return /** @type {LocalizedString} */ ("Navnet er dækket af et sort felt")
});